import { LayerComponentBase } from '@/stellar-globe-components'
import { store } from '@/store'
import { clip, V4 } from '@/utils/math'
import { tractCorner } from '@/utils/tract'
import { Layer, path, View } from "@hscmap/stellar-globe"
import { Component } from "vue-property-decorator"

class Renderer extends path.Renderer {
  constructor(gl: WebGLRenderingContext, readonly vm: LevelTract) {
    super(gl)
  }

  refreshArray() {
    const quest = this.vm.session.quest!
    const w = 0.005
    const paths: path.Path[] = []
    const tract_ids = quest.level.tract_ids_for_user!
    const color_unfinished: V4 = [0, 0.5, 1, 0.75]
    const color_focus: V4 = [0, 1, 1, 1]
    const color_done: V4 = [1, 0, 0, 0.25]

    /*
     * tract_index: quest内の何番目のtractか
     * tract分割の結果, quest.tract_idsの中にquest.tract_idが含まれていない場合がある
     */

    const makeTractFrame = (tract_id: number, color: V4) => {
      // @ts-ignore
      const points = tractCorner(tract_id).map((v) => new path.Point([v[0], v[1], v[2]], color, w))
      paths.push(new path.Path(points, true, path.JOINT.MITER))
    }

    if (store.galaxyCruise.series === 'infinite') {
      // これをしておかないと枠がたくさん表示されてしまう・・
      makeTractFrame(quest.tract_id, color_focus)
    }
    else {
      for (let tract_index = 0; tract_index < tract_ids.length; ++tract_index) {
        if (tract_index == quest.tract_index) {
          makeTractFrame(quest.tract_id, color_focus)
        }
        else {
          makeTractFrame(tract_ids[tract_index], tract_index < quest.tract_index ? color_done : color_unfinished)
        }
      }
    }

    this.setPaths(paths)
  }
}

class TractFrameLayer extends Layer {
  private pr!: Renderer

  constructor(readonly vm: LevelTract) {
    super()
  }

  private unwatch!: () => void

  onAdd() {
    this.pr = new Renderer(this.globe.gl, this.vm)
    this.unwatch = this.vm.$watch(() => this.vm.session.quest, (quest) => {
      this.pr.refreshArray()
      this.globe.requestRefresh()
    }, { immediate: true, deep: true })
  }

  onRemove() {
    this.unwatch()
    this.pr.release()
  }

  render(view: View) {
    const minFovy = 0.01
    this.pr.alpha = clip((view.camera.fovy - minFovy) * 20, 0, 1)
    this.pr.render(view)
  }
}

@Component
export class LevelTract extends LayerComponentBase<TractFrameLayer> {
  get session() {
    return store.galaxyCruise.session!
  }

  newLayer() {
    return new TractFrameLayer(this)
  }
}
